module.exports = __webpack_public_path__ + "img/nomina.0bbd541a.png";